import * as React from "react";
import type { SVGProps } from "react";
const SvgAngleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="angle_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M789.333 170.667a64 64 0 1 0 0 128 64 64 0 0 0 0-128zm-149.333 64a149.333 149.333 0 1 1 71.808 127.658L610.347 463.83A404.096 404.096 0 0 1 724.779 768H896a42.667 42.667 0 1 1 0 85.333H369.621a149.333 149.333 0 1 1-70.656-198.826l355.542-355.542A148.779 148.779 0 0 1 640 234.667zM639.317 768a318.848 318.848 0 0 0-89.301-243.84l-187.69 187.648A149.12 149.12 0 0 1 382.505 768h256.811zm-340.65 21.333a64 64 0 1 0-128 0 64 64 0 0 0 128 0z"
    />
  </svg>
);
export default SvgAngleIcon;
